import FJTextToImageConfig from '../../config/appConfig/FJTextToImageConfig';
import FJConstant from '../../constants/FJConstant';
import FJNetworkStore from '../../store/FJNetworkStore';
import {
    setSliceAiTextToImageHistoryList,
    setSliceAiTextToImageHistoryLoadStatus,
    setSliceIsShowAIImageHistoryModal,
    setSliceAiImageToImageHistoryLoadStatus,
    setSliceAiImageToImageHistoryList,
    setSliceAiVideoHistoryLoadStatus,
    setSliceAiVideoHistoryList,
} from '../slices/FJSliceAiHistoryCommon';
import FJUtil from '../../util/FJUtil';
import FJAppConstant from '../../constants/FJAppConstant';
import FJImageToImageConfig from '../../config/appConfig/FJImageToImageConfig.js';
import FJAIVideoGeneratorConfig from '../../config/appConfig/FJAIVideoGeneratorConfig.js';

const FJActionAiHistoryCommon = {
    /**
     * @desc 初始化ai文本到图像历史记录列表
     * @returns
     */
    initAiTextToImageHistoryList: function (isRefresh = false) {
        return async (dispatch, getState) => {
            const { aiTextToImageHistoryLoadStatus } = getState().aiHistoryCommon;
            if (
                (aiTextToImageHistoryLoadStatus === FJConstant.LOADING ||
                    aiTextToImageHistoryLoadStatus === FJConstant.SUCCESS) &&
                !isRefresh
            )
                return;

            try {
                dispatch(setSliceAiTextToImageHistoryLoadStatus(FJConstant.LOADING));

                const list = await FJNetworkStore.getTaskList(FJTextToImageConfig.historyListType);
                if (list && list.length) {
                    const historyList = await FJUtil.parseList(list, {
                        type: FJConstant.HISTORY,
                        resultImageKey: FJTextToImageConfig.resultImageKey,
                        originalImageKey: FJTextToImageConfig.originalImageKey,
                        appType: FJAppConstant.TEXT_TO_IMAGE,
                    });
                    dispatch(setSliceAiTextToImageHistoryList(historyList));
                } else {
                    dispatch(setSliceAiTextToImageHistoryList([]));
                }
                dispatch(setSliceAiTextToImageHistoryLoadStatus(FJConstant.SUCCESS));
            } catch (error) {
                dispatch(setSliceAiTextToImageHistoryList([]));
                dispatch(setSliceAiTextToImageHistoryLoadStatus(FJConstant.ERROR));
            }
        };
    },

    /**
     * @desc 初始化ai图像到图像历史记录列表
     * @returns
     */
    initAiImageToImageHistoryList: function (isRefresh = false) {
        return async (dispatch, getState) => {
            const { aiImageToImageHistoryLoadStatus } = getState().aiHistoryCommon;
            if (
                (aiImageToImageHistoryLoadStatus === FJConstant.LOADING ||
                    aiImageToImageHistoryLoadStatus === FJConstant.SUCCESS) &&
                !isRefresh
            )
                return;

            try {
                dispatch(setSliceAiImageToImageHistoryLoadStatus(FJConstant.LOADING));

                const list = await FJNetworkStore.getTaskList(FJImageToImageConfig.historyListType);
                if (list && list.length) {
                    const historyList = await FJUtil.parseList(list, {
                        type: FJConstant.HISTORY,
                        resultImageKey: FJImageToImageConfig.resultImageKey,
                        originalImageKey: FJImageToImageConfig.originalImageKey,
                        appType: FJAppConstant.IMAGE_TO_IMAGE,
                    });
                    dispatch(setSliceAiImageToImageHistoryList(historyList));
                } else {
                    dispatch(setSliceAiImageToImageHistoryList([]));
                }
                dispatch(setSliceAiImageToImageHistoryLoadStatus(FJConstant.SUCCESS));
            } catch (error) {
                dispatch(setSliceAiImageToImageHistoryList([]));
                dispatch(setSliceAiImageToImageHistoryLoadStatus(FJConstant.ERROR));
            }
        };
    },

    /**
     * @desc 初始化ai视频历史记录列表
     * @returns
     */
    initAiVideoHistoryList: function (isRefresh = false) {
        return async (dispatch, getState) => {
            const { aiVideoHistoryLoadStatus } = getState().aiHistoryCommon;
            if (
                (aiVideoHistoryLoadStatus === FJConstant.LOADING || aiVideoHistoryLoadStatus === FJConstant.SUCCESS) &&
                !isRefresh
            )
                return;

            try {
                dispatch(setSliceAiVideoHistoryLoadStatus(FJConstant.LOADING));

                const list = await FJNetworkStore.getTaskList(FJAIVideoGeneratorConfig.historyListType);
                if (list && list.length) {
                    const historyList = await FJUtil.parseList(list, {
                        type: FJConstant.HISTORY,
                        resultImageKey: FJAIVideoGeneratorConfig.resultVideoKey,
                        originalImageKey: FJAIVideoGeneratorConfig.originalImageKey,
                        appType: FJAppConstant.AI_VIDEO_GENERATOR,
                    });
                    dispatch(setSliceAiVideoHistoryList(historyList));
                } else {
                    dispatch(setSliceAiVideoHistoryList([]));
                }
                dispatch(setSliceAiVideoHistoryLoadStatus(FJConstant.SUCCESS));
            } catch (error) {
                dispatch(setSliceAiVideoHistoryList([]));
                dispatch(setSliceAiVideoHistoryLoadStatus(FJConstant.ERROR));
            }
        };
    },

    /**
     * @description
     * @param isShow
     * @returns {(function(*): void)|*}
     */
    setIsShowAIImageHistoryModalAction: function (isShow) {
        return dispatch => {
            dispatch(setSliceIsShowAIImageHistoryModal(isShow));
        };
    },

    /**
     * @description
     * @returns {(function(*): void)|*}
     */
    showAIImageHistoryListAction: function () {
        return dispatch => {
            dispatch(this.setIsShowAIImageHistoryModalAction(true));
            dispatch(this.initAiTextToImageHistoryList());
            dispatch(this.initAiImageToImageHistoryList());
        };
    },

    /**
     * @description 登录后初始化ai历史记录列表
     * @returns {(function(*): void)|*}
     */
    loginAfterAction: function () {
        return (dispatch, getState) => {
            const appType = getState().common.appType;

            switch (appType) {
                case FJAppConstant.AI_VIDEO_GENERATOR:
                    dispatch(setSliceAiTextToImageHistoryLoadStatus(FJConstant.DEFAULT));
                    dispatch(setSliceAiImageToImageHistoryLoadStatus(FJConstant.DEFAULT));
                    break;
                case FJAppConstant.AI_VIDEO_DUB:
                    dispatch(setSliceAiVideoHistoryLoadStatus(FJConstant.DEFAULT));
                    break;
                default:
                    break;
            }
        };
    },
};

export default FJActionAiHistoryCommon;
